module.exports = __webpack_public_path__ + "img/icon_zxlx.4cf137fd.png";